export default __webpack_public_path__ + "static/media/soylent-logo.c463c57a.png";